import React from 'react';
import { Paper, makeStyles, Theme } from '@material-ui/core';
import clsx from 'clsx';
import { MonitorSeverity } from '@moderepo/mode-apis';
import { useModePanelStyle, useModeFormStyle, BaseInfoCompProps, BaseEntityField, InfoCompPanelHeader, ModeInfoCompTextInputField }
    from '@moderepo/mode-app-components';



const useStyle = makeStyles((theme: Theme) => {
    return {
        severity: {
            '& input': {
                fontWeight: 'bold',
            },

            '&.level-0': {
                '& input': {
                    color: theme.palette.success.main,
                },
            },
            '&.level-1000': {
                '& input': {
                    color: theme.palette.info.main,
                },
            },
            '&.level-6000': {
                '& input': {
                    color: theme.palette.warning.main,
                },
            },
            '&.level-11000': {
                '& input': {
                    color: theme.palette.error.main,
                },
            },
        },
    };
});


interface RCAlertInfoProps extends BaseInfoCompProps {
    readonly fields: {
        readonly id: BaseEntityField<number>;
        readonly monitorId: BaseEntityField<number>;
        readonly name: BaseEntityField<string>;
        readonly description: BaseEntityField<string>;
        readonly severity: BaseEntityField<MonitorSeverity>;
        readonly createdConditions: BaseEntityField<string>;
        readonly creationTime: BaseEntityField<string>;
    }
}


/**
 * This is a DUMB component used for displaying an Alert instance info. This component does not have any logic. All it does it display
 * data based on the props provided by the container. All action done in this component will be dispatched back to the
 * container's handler.
 */
export const RCAlertInfo = (props: RCAlertInfoProps) => {

    const panelClasses = useModePanelStyle();
    const formClasses = useModeFormStyle();
    const classes = useStyle();


    return (
        <Paper
            elevation={2}
            className={clsx(panelClasses.root, props.className)}
        >
            <InfoCompPanelHeader {...props} />
            <div className={clsx(panelClasses.panelContent)}>
                <form className={clsx(formClasses.root, props.formProps?.className)} noValidate autoComplete="on" method="POST">
                    <div className={formClasses.formInputGroup}>
                        <ModeInfoCompTextInputField
                            className={formClasses.formInputField}
                            inputType="text"
                            compProps={props}
                            inputProps={props.fields.id}
                            fieldName="id"
                            inputValue={props.fields.id.displayValue ?? props.fields.id.value}
                        />
                        <ModeInfoCompTextInputField
                            className={formClasses.formInputField}
                            inputType="text"
                            compProps={props}
                            inputProps={props.fields.monitorId}
                            fieldName="monitorId"
                            inputValue={props.fields.monitorId.displayValue ?? props.fields.monitorId.value}
                        />
                        <ModeInfoCompTextInputField
                            className={formClasses.formInputField}
                            inputType="text"
                            compProps={props}
                            inputProps={props.fields.name}
                            fieldName="name"
                            inputValue={props.fields.name.displayValue ?? props.fields.name.value}
                        />
                        <ModeInfoCompTextInputField
                            className={formClasses.formInputField}
                            inputType="text"
                            multiline
                            compProps={props}
                            inputProps={props.fields.description}
                            fieldName="description"
                            inputValue={props.fields.description.displayValue ?? props.fields.description.value}
                        />
                        <ModeInfoCompTextInputField
                            className={clsx(formClasses.formInputField, classes.severity, `level-${props.fields.severity.value}`)}
                            inputType="text"
                            compProps={props}
                            inputProps={props.fields.severity}
                            fieldName="severity"
                            inputValue={props.fields.severity.displayValue ?? props.fields.severity.value}
                        />
                        <ModeInfoCompTextInputField
                            className={formClasses.formInputField}
                            inputType="text"
                            multiline
                            compProps={props}
                            inputProps={props.fields.createdConditions}
                            fieldName="createdConditions"
                            inputValue={props.fields.createdConditions.displayValue ?? props.fields.createdConditions.value}
                        />
                        <ModeInfoCompTextInputField
                            className={formClasses.formInputField}
                            inputType="text"
                            compProps={props}
                            inputProps={props.fields.creationTime}
                            fieldName="creationTime"
                            inputValue={props.fields.creationTime.displayValue ?? props.fields.creationTime.value}
                        />
                    </div>
                </form>
            </div>

        </Paper>
    );

};
